import React, { useMemo } from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import { Queries } from '@ers/data';

const getQueryFromSelectedBreakpoints = ({ not, phone, tabletPortrait, tabletLandscape, desktop, fullHD }) => {
    const query = not ? Queries.extensions.toArray() : [];
    if(not){
        if (phone) query.extensions.remove(Queries.phone);
        if (tabletPortrait) query.extensions.remove(Queries.tabletPortrait);
        if (tabletLandscape) query.extensions.remove(Queries.tabletLandscape);
        if (desktop) query.extensions.remove(Queries.desktop);
        if (fullHD) query.extensions.remove(Queries.fullHD);
    }
    else{

        if (phone) query.push(Queries.phone);
        if (tabletPortrait) query.push(Queries.tabletPortrait);
        if (tabletLandscape) query.push(Queries.tabletLandscape);
        if (desktop) query.push(Queries.desktop);
        if (fullHD) query.push(Queries.fullHD);
    }
    const result = query.join(', ');
    return result;
};
export default function Media({ children, ...modifiers }) {
    const query = useMemo(() => getQueryFromSelectedBreakpoints({ ...modifiers }), modifiers.extensions.toArray());
    return <MediaQuery query={query}>{children}</MediaQuery>;
}

Media.propTypes = {
    phone: PropTypes.bool,
    tabletPortrait: PropTypes.bool,
    tabletLandscape: PropTypes.bool,
    desktop: PropTypes.bool,
    fullHD: PropTypes.bool,
    not: PropTypes.bool
};

Media.defaultProps = {
    phone: false,
    tabletPortrait: false,
    tabletLandscape: false,
    desktop: false,
    fullHD: false,
    not: false
};